import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMerchant } from '../hooks/useMerchant';
import { MerchantMandatoryPasswordModal } from './MerchantMandatoryPasswordModal';
import '../pages/MerchantPortal.css';

/**
 * Envolve as rotas /merchant usando Supabase Auth. A sessao e carregada no
 * MerchantProvider e o portal so abre quando existe Merchant vinculado ao JWT.
 */
export function MerchantRouteGuard() {
    const location = useLocation();
    const { merchant, isAuthenticated, isLoading } = useMerchant();

    if (isLoading) {
        return (
            <div className="merchant-portal merchant-portal--loading" role="status" aria-live="polite">
                <div className="merchant-loading-inner">
                    <div className="merchant-loading-spinner" aria-hidden />
                    <p>Verificando sua conta...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated || !merchant) {
        return <Navigate to="/merchant-login" replace state={{ from: location.pathname }} />;
    }

    if (merchant.mustChangePassword) {
        return <MerchantMandatoryPasswordModal />;
    }

    return <Outlet />;
}
